import { Label, TicketType, SprintStatus } from "../../types";

export interface BacklogTicket {
  id: string;
  type: TicketType;
  name: string;
  release: string;
  sprint: string;
  epic: {
    name: string;
    color: string;
  };
  labels: Label[];
}

export enum SelectionTopBarOptionsEnum {
  DUPLICATE = "duplicate",
  ARCHIVE = "archive",
  EXPORT = "export",
  STATUS = "status",
  USER = "assignee",
  CALENDAR = "dueDate",
  RELEASE = "release",
  SPRINT = "sprint",
}

export enum SprintTabsEnum {
  NEXT_SPRINTS = "NEXT SPRINTS",
  PAST_SPRINTS = "PAST SPRINTS",
}

export interface SprintItem {
  title: {
    name: string;
    color: string;
  };
  story: string;
  task: string;
  bug: string;
  duration?: string;
  hours?: number;
  totalHours?: number;
  status?: SprintStatus;
}

export interface ComponentItem {
  title: {
    name: string;
    color: string;
  };
  story: string;
  task: string;
  bug: string;
  canceled: boolean;
}

export interface StoryItem {
  id: string;
  title: {
    name: string;
    color: string;
  };
  task: string;
  bug: string;
}
export interface IPlanningTicketTypeSummary {
  typeId: string;
  typeName?: string;
  count: number;
  ticketIds: string[];
}
export interface IPlanningTicketType {
  typeId: string;
  typeName?: string;
  count: number;
  ticketIds: string[];
  icon: string;
}
export interface IPlanningBacklog {
  totalTickets: number;
  ticketIds: string[];
  ticketTypes: IPlanningTicketType[];
}
export interface IPlanningViewsGroup {
  id?: string;
  name: string;
  color?: string;
  totalTickets?: number;
  ticketIds?: string[];
  ticketTypes: IPlanningTicketType[];
  isUnassigned?: boolean;
  totalCapacityHours?: number;
  allocatedCapacity?: number;
  endDate?: string;
  startDate?: string;
  status?: string;
}

export interface IPlanningItems {
  backlog: IPlanningBacklog;
  selectedView: {
    viewBy: PlanningViewBy;
    groups: IPlanningViewsGroup[];
  };
}
export enum PlanningViewBy {
  BACKLOG = "backlog",
  COMPONENTS = "components",
  EPICS = "epics",
  STORIES = "stories",
  SPRINTS = "sprints",
  NEXT_RELEASES = "nextReleases",
  PAST_RELEASES = "pastReleases",
}
export type PlanningTileId = "backlog" | string;

export interface ISelectedPlanningTile {
  id: PlanningTileId;
  ticketIds: string[];
}

export interface BacklogState {
  isLoading: boolean;
  isPlanningFilterLoading: boolean;
  planningItems: IPlanningItems;
  selectedViewType: PlanningViewBy | null;
  selectedPlanningTile: ISelectedPlanningTile | null;
}
